/**
 * DashboardSidebar - Slot: right column below "Recent Images".
 *
 * Mock order: QuickActions -> TransactionList -> InviteFriendsWidget (bottom).
 * The plan card is intentionally NOT here anymore (moved to DashboardStatsRow).
 * The whole block is gated by canManageCredits (mirrors prior behavior).
 */

import { InviteFriendsWidget } from '@/components/v2/referral';
import type { Transaction } from '@/types';
import { DashboardQuickActions } from './DashboardQuickActions';
import { DashboardTransactionList } from './DashboardTransactionList';

interface DashboardSidebarProps {
  transactions: Transaction[];
  canManageCredits: boolean;
}

export function DashboardSidebar({ transactions, canManageCredits }: DashboardSidebarProps) {
  if (!canManageCredits) {
    return null;
  }

  return (
    <div className="space-y-4">
      <DashboardQuickActions />
      <DashboardTransactionList transactions={transactions} />
      <InviteFriendsWidget />
    </div>
  );
}
